import React from 'react';
import { Link } from 'react-router-dom';

import clsx from 'clsx';
import { useSetRecoilState } from 'recoil';

import { sideMenuForceOpen } from '../../model/state/sideMenuState';

type SideMobileMenuButtonAttributes = {
  name: string;
  link: string;
};

interface SideMobileMenuButtonProps {
  sideMenuButtonAttributes: SideMobileMenuButtonAttributes;
}

export const SideMobileMenuButton: React.FC<SideMobileMenuButtonProps> = ({
  sideMenuButtonAttributes,
}) => {
  const setOpenMenu = useSetRecoilState(sideMenuForceOpen);

  return (
    <div
      className={clsx('flex flex-row justify-start rounded-[8px] pl-[8px]')}
      onClick={() => setOpenMenu(false)}
    >
      <Link
        to={sideMenuButtonAttributes.link}
        className="font-inter flex items-center justify-center pb-[6px] pt-2 text-[15px] text-black no-underline"
      >
        <span className="pl-2">{sideMenuButtonAttributes.name}</span>
      </Link>
    </div>
  );
};
